export const blue = '#0059D6';
export const green = '#1ADB44';
export const lightBlue = '#B5D2FF';
export const limeGreen = '8FCF2F';
export const orange = '#FFB21C';
export const pink = '#DB1AC8';
export const red = '#FF5353';
export const yellow = '#DBC81A';
export const gray = '#C8C8C8';

export type CustomColor =
  | 'blue'
  | 'green'
  | 'lightBlue'
  | 'limeGreen'
  | 'orange'
  | 'pink'
  | 'red'
  | 'yellow';
